import { mtechnavi } from '~/shared/libs/clientsdk';
import { AppSaveWorker } from '..';

export interface SaveOcpIntroduction {
  actionName: 'saveOcpIntroduction';
  request: mtechnavi.api.company.IBusinessUnitIntroduction;
}

export const saveOcpIntroduction = async (
  worker: AppSaveWorker,
  req: mtechnavi.api.company.IBusinessUnitIntroduction
) => {
  const saveMethodName =
    'mtechnavi.api.company.BusinessUnitManagementService/SaveBusinessUnitIntroduction';

  return worker.invokeListRequest(saveMethodName, {
    businessUnitIntroduction: req,
  });
};
